import api from './api';

export const getAllIpos = () => api.get('/ipos');
export const getIpoById = (id) => api.get(`/ipos/${id}`);
export const createIpo = (data) => api.post('/ipos', data);
export const updateIpo = (id, data) => api.put(`/ipos/${id}`, data);
export const deleteIpo = (id) => api.delete(`/ipos/${id}`);
export const uploadIpoMedia = (formData) => api.post('/ipos/upload-media', formData);
